import { render, staticRenderFns } from "./ArtworkSidebarAccordion.vue?vue&type=template&id=2c655320&"
import script from "./ArtworkSidebarAccordion.vue?vue&type=script&lang=js&"
export * from "./ArtworkSidebarAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkSidebarAccordion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports